import * as React from 'react';
import { verify } from '../api/api';
import { useNavigate, useSearchParams } from 'react-router-dom';
import HourglassTopRoundedIcon from '@mui/icons-material/HourglassTopRounded';
import BtnFilled from '../components/BtnOutlined';

import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';

const Verify = ({ userLoggedIn }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [res, setRes] = React.useState({});
  const [progress, setProgress] = React.useState(true);

  React.useEffect(() => {
    const ticket = searchParams.get('ticket');
    verify(ticket, setRes, setProgress);
  }, []);

  const goTo = async () => {
    navigate('/');
  };

  return (
    <div className="flex w-full min-h-screen p-4 items-start justify-center bg-gradient-to-r from-[#ededed] to-[#dcdcdc]">
      <div className="w-full max-w-lg">
        <form className="bg-white shadow-2xl rounded-3xl border-b border border-gray-200 px-8 pt-6 pb-8 mb-4">
          {progress ? (
            <>
              <div className="flex justify-center mb-4">
                <HourglassTopRoundedIcon className="fill-orange-500 animate-spin w-8 h-8"></HourglassTopRoundedIcon>
              </div>
            </>
          ) : (
            <>
              {res.status === 'success' ? (
                <div className="flex items-center mb-4">
                  <CheckCircleOutlineRoundedIcon className="text-green-500 w-8 h-8"></CheckCircleOutlineRoundedIcon>
                  <p className="text-gray-800 ml-4 mt-0.5 text-lg font-bold truncate">Подтверждено</p>
                </div>
              ) : (
                <>
                  <div className="flex items-center mb-2">
                    <CheckCircleOutlineRoundedIcon className="text-red-500 w-8 h-8" />
                    <p className="text-gray-800 ml-4 mt-0.5 text-lg font-bold truncate">Произошла ошибка подтверждения</p>
                  </div>
                  {res?.error && <p className="text-gray-600 text-center pb-2">{res?.error}</p>}
                </>
              )}
            </>
          )}
          <div className="mb-4">
            <BtnFilled title={userLoggedIn ? 'Перейти в личный кабинет' : 'Войти'} btnCb={() => goTo()}></BtnFilled>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Verify;
